cockpitApp.directive('loadingDots', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/loading-dots'
  };
});
